import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {IonRouterOutlet} from "@ionic/react";
import FourOFour from "../pages/utils/FourOFour";
import HomePage from "../pages/tabs/HomePage";
import RouteService from "../services/routes/RouteService";
import MapPage from "../pages/tabs/MapPage";
import OperationRouter from "./OperationRouter";

/**
 * Lists all the routes of the application.
 * @author Alizée Grand
 * @version 1.3
 * @creation 13/08/2021
 * @last_update 10/01/2022
 **/
class Router extends React.Component<{}> {

    render() {

        return (
            <Switch>
                <Route
                    path={RouteService.BASIC_URL}
                    render={() => (
                        <IonRouterOutlet>
                            <Route exact path={RouteService.getHome()}>
                                <HomePage/>
                            </Route>

                            <Route exact path={RouteService.getMap()}>
                                <MapPage/>
                            </Route>

                            <Route path={RouteService.getOperation()} render={() => (
                                <OperationRouter/>
                            )}/>

                            <Route exact path={RouteService.BASIC_URL}>
                                <Redirect to={RouteService.getHome()}/>
                            </Route>

                            <Route component={FourOFour}/>
                        </IonRouterOutlet>
                    )}
                />

                <Route exact path="/">
                    <Redirect to={RouteService.getHome()}/>
                </Route>

                <Route exact path="">
                    <Redirect to={RouteService.getHome()}/>
                </Route>

                <Route component={FourOFour}/>
            </Switch>
        );
    }

}

export default Router;
